import FlumpObject from "../../general/objects/FlumpObject";
import { audioPlayer } from "../../PhaserExtension";
import * as GameModel from "../../models/GameModel";

export default class MuppetCharacter extends FlumpObject
{
    constructor(game, config, library, id)
    {
        super(game, config, library);
        this.id = id;

        this.onCompletedPass = new Phaser.Signal();
        this.onDecision = new Phaser.Signal();
        this.targetPosition = this.position;
        this.loop(this.keys.idle);
    }

    greet()
    {
        var langString = GameModel.data.english ? "Eng" : "Esp";
        var playerString = GameModel.data.isTwoPlayer ? "2p" : "1p";
        this.playOnce(this.keys["greet" + langString + playerString], true, true);
    }

    passBall(callback, callbackContext)
    {
        this.loop(this.keys.idle);
        this.playOnce(this.keys.pass, true, true);
        this.onComplete.addOnce(this.passComplete, this);
        this.onCompletedPass.addOnce(callback, callbackContext);
    }

    passComplete()
    {
        this.loop(this.keys.idle);
        this.playOnce(this.keys.passEnd, true, true);
        this.onCompletedPass.dispatch();
    }

    receiveBall(callback, callbackContext)
    {
        this.loop(this.keys.idleWithBall);
        this.playOnce(this.keys.receive, true, true);
        this.onComplete.addOnce(this.onReceiveComplete.bind(this, callback, callbackContext));
    }

    onReceiveComplete(callback, callbackContext)
    {
        var soundID = this.game.rnd.between(0, this.config.receiveSoundArray.length - 1);
        var langString = GameModel.data.english ? "Eng" : "Esp";
        this.playOnce(this.config.display["lipSync" + langString + soundID], false, true);
        audioPlayer.play(this.game, this.config.receiveSoundArray[soundID], callback, callbackContext);
    }

    receiveBallInCutscene()
    {
        this.loop(this.keys.idleWithBall);
        this.playOnce(this.keys.receive, true, true);
    }

    makeChoice(callback, callbackContext)
    {
        this.loop(this.keys.idleWithBall);
        this.playOnce(this.keys.revealEnd, true, true);
        this.onComplete.addOnce(this.onRevealEndComplete, this);
        this.onDecision.addOnce(callback, callbackContext);
    }

    onRevealEndComplete()
    {
        this.playOnce(this.keys.think, true, true);
        this.onComplete.addOnce(this.onThinkComplete, this);
    }

    onThinkComplete()
    {
        this.onDecision.dispatch(this.id);
    }

    destroy(children)
    {
        this.onCompletedPass.dispose();
        this.onDecision.dispose();
        super.destroy(children);
    }
}
